import React from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';
import {
  ValidationError,
  ErrorMessage,
} from '../../../modules/brochure/components/StyledComponents/StyledComponents';

const Container = styled.div`
  position: relative;
  display: block;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  font-size: 16px;
  transition: 1ms all ease-in-out;

  ${(props) => (props.disabled ? 'opacity: 0.5' : undefined)};

  > div {
    border: 2px solid ${(props) => (props.borderColour ? props.borderColour : '#F8444F')};
    color: #e9e9e9;
    border-radius: ${(props) => props.borderRadius}px;
    position: absolute;
    height: ${(props) => props.size}px;
    width: ${(props) => props.size}px;
    top: 0;
    background-color: transparent;
    z-index: 1;
    transition: 1ms all ease-in-out;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-around;

    &:after {
      content: '';
      position: relative;
      display: block;
      top: 100%;
      width: 70%;
      height: 140%;
      border: solid ${(props) => (props.colour ? props.colour : 'black')};
      border-width: 0 0.3875em 0.3875em 0;
      transform: rotate(45deg) scale(1);
      opacity: 0;
      transition: 2ms all cubic-bezier(0.68, -0.55, 0.265, 1.55);
    }
  }

  > input {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 2;

    &:disabled {
      cursor: not-allowed;
    }

    // TODO: Check Accessibility
    &:active + div,
    &:focus + div,
    &:hover + div {
      background-color: transparent;
    }

    &:checked + div {
      background-color: transparent;

      &:after {
        top: -10%;
        opacity: 1;
        transform: rotate(45deg) scale(0.5);
      }
    }
  }
`;
const Label = styled.div`
  margin-right: 10px;
  margin-left: 20px;
`;
export const CheckboxInput = ({ input, colour, borderColour }) => {
  return (
    <Container
      disabled={false}
      size={35}
      border={1}
      borderColour={borderColour}
      colour={colour}
      borderRadius={2}
      fontSize={12}
    >
      <input type="checkbox" {...input} checked={input.value} />
      <div />
    </Container>
  );
};

const PublicCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ValidationState = ({ showError, children }) => {
  return <ValidationError showError={showError}>{children}</ValidationError>;
};

export const PublicCheckbox = ({ input, meta, label }) => {
  return (
    <ValidationState showError={meta.touched && meta.error} key={input.name}>
      <PublicCheckboxContainer>
        <Field name={input.name} component={CheckboxInput} />
        <Label>{label}</Label>
      </PublicCheckboxContainer>
      {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
    </ValidationState>
  );
};

export const PublicCheckboxAfter = ({ input, meta, label }) => {
  return (
    <ValidationState showError={meta.touched && meta.error} key={input.name}>
      <PublicCheckboxContainer>
        <Label>{label}</Label>
        <Field name={input.name} component={CheckboxInput} />
      </PublicCheckboxContainer>
      {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
    </ValidationState>
  );
};
